/* Misu first-party cart activity. No anonymous email inference or public API key. */
(function () {
  'use strict';
  var KEY = 'misu_mailroom_v1', endpoint = 'https://mailroom.dailymisu.com/api/webhooks/storefront';
  var busy = false, timer, failures = 0;
  function allowed() {
    if (navigator.globalPrivacyControl || window.MisuPrivacy && !window.MisuPrivacy.allowsMarketing()) return false;
    var privacy = window.Shopify && Shopify.customerPrivacy;
    return !!(privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed());
  }
  function read() {
    try {
      var state = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (!state || typeof state !== 'object' || Array.isArray(state)) return {};
      if (state.token && (!state.identityAt || Date.now() - state.identityAt > 30 * 86400000)) { clear(); return {}; }
      state.events = (Array.isArray(state.events) ? state.events : []).filter(function (e) { return e && Date.parse(e.occurredAt) > Date.now() - 86400000; }).slice(-20);
      write(state);
      return state;
    } catch (_) { return {}; }
  }
  function write(value) { try { localStorage.setItem(KEY, JSON.stringify(value)); } catch (_) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (_) {} clearTimeout(timer); }
  function flush() {
    if (!allowed()) { clear(); return; }
    if (busy || navigator.onLine === false) return;
    var state = read();
    if (!state.token || !state.events || !state.events.length) return;
    var event = state.events[0];
    if (Date.now() - Date.parse(event.occurredAt) > 86400000) { state.events.shift(); write(state); return flush(); }
    busy = true;
    fetch(endpoint, { method: 'POST', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify({ token: state.token, event: event })
    }).then(function (response) {
      if (response.status === 401) { clear(); return; }
      if (!response.ok) throw new Error('retry');
      var latest = read(); latest.events = (latest.events || []).filter(function (e) { return e.id !== event.id; }); write(latest); failures = 0;
    }).catch(function () { failures += 1; }).then(function () {
      busy = false;
      if (failures < 6) timer = setTimeout(flush, failures ? Math.min(30000, 1000 * Math.pow(2, failures)) : 150);
    });
  }
  window.addEventListener('misu:privacy-changed', function () { if (!allowed()) clear(); });
  window.addEventListener('misu:mailroom-identity', function (e) {
    if (!allowed() || !e.detail || typeof e.detail.token !== 'string') return;
    var state = read(); state.token = e.detail.token; state.identityAt = Date.now(); write(state); failures = 0; flush();
  });
  function captureCart(cart) {
    if (!allowed() || !cart || !Array.isArray(cart.items)) return;
    var state = read(); state.events = (state.events || []).slice(-19);
    state.events.push({id:crypto.randomUUID(),name:'cart_added',occurredAt:new Date().toISOString(),items:cart.items.map(function(i){
      var row={id:String(i.variant_id),quantity:i.quantity,properties:i.properties||{}};
      if(i.selling_plan_allocation)row.selling_plan=String(i.selling_plan_allocation.selling_plan.id);
      return row;
    })});
    write(state); failures=0; flush();
  }
  window.addEventListener('misu:cart-snapshot', function (event) {
    if (!allowed()) return;
    // Queue the confirmed cart synchronously before a PDP can leave for checkout.
    if (event.detail && event.detail.cart) { captureCart(event.detail.cart); return; }
    fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
      .then(function(r){if(!r.ok)throw Error('cart');return r.json();}).then(captureCart).catch(function(){});
  });
  document.addEventListener('visitorConsentCollected', function () { if (!allowed()) clear(); else flush(); });
  window.addEventListener('online', function () { failures = 0; flush(); });
  // Wait until Shopify's consent API has initialized. Never treat its absence as consent.
  if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function (error) { if (!error) flush(); });
})();
